import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

type MenuItem = {
  to?: string;
  icon: string;
  label: string;
  trackCategory: string;
  trackAction: string;
  trackLabel: string;
  target?: string;
};

export const menuItems = (isAdmin: boolean): MenuItem[] => {
  if (ApplicationDomainUtility.isB2b) return [];
  return [
    ...(isAdmin
      ? [
          {
            to: '/admin',
            icon: 'fa-regular fa-house',
            label: 'Admin',
            trackCategory: 'Mobile-Nav-Bar',
            trackAction: 'Admin',
            trackLabel: 'Admin',
          },
        ]
      : []),
    {
      to: '/blog',
      icon: 'fa-regular fa-book',
      label: 'Blogs',
      trackCategory: 'Mobile-Nav-Bar',
      trackAction: 'Blogs',
      trackLabel: 'Blogs',
    },
    {
      to: '/about_us',
      icon: 'fa-regular fa-circle-exclamation',
      label: 'About us',
      trackCategory: 'Mobile',
      trackAction: 'AboutUs',
      trackLabel: 'Mobile track',
    },
    {
      to: '/faq',
      icon: 'fa-regular fa-circle-question',
      label: 'FAQ',
      target: '_blank',
      trackCategory: 'Mobile-Nav-Bar',
      trackAction: 'FAQ',
      trackLabel: 'faq',
    },
    {
      to: '/policy',
      icon: 'fa-regular fa-memo-pad',
      label: 'Policy',
      trackCategory: 'Mobile',
      trackAction: 'Policy',
      trackLabel: 'Mobile track',
    },
    {
      to: 'mailto:support@quantman.in',
      icon: 'fa-regular fa-envelope',
      label: 'Email',
      target: '_blank',
      trackCategory: 'Mobile',
      trackAction: 'Email',
      trackLabel: 'Mobile track',
    },
    {
      to: '/terms_and_conditions',
      icon: 'fa-regular fa-handshake',
      label: 'Terms & Conditions',
      trackCategory: 'Mobile',
      trackAction: 'TermAndConditions',
      trackLabel: 'Mobile track',
    },
  ];
};
